<template>
  <div id="app">
    <NavBar 
      v-if="r7eApp.useNavbar()"
      :get-nav-bar-data="getAppNavBarData"
      :r7e-app="r7eApp"
    />    
    <NavSideBar 
      v-if="r7eApp.useSidebar()"
      :get-nav-bar-data="getAppNavBarData"
      :r7e-app="r7eApp"
    /> 
    <div 
      class="container" 
      :class="{ 'nav-mode-navbar': r7eApp.useNavbar(), 'nav-mode-sidebar': r7eApp.useSidebar() }"
    >
      <ToastNotification
        position="top-right"
        group="tr"
      />
      <ToastNotification
        position="top-center"
        group="tc"
      />
      <ToastNotification
        position="bottom-right"
        group="br"
      />
      <ToastNotification
        position="bottom-center"
        group="bc"
      />      
      <router-view />
    </div> 
    <FooterBar
      :build-info="build_info"
    />
  </div>
  <DebugInfo
    :r7e-app="r7eApp"
    :build-info="build_info"
    v-if="r7eApp.isDebugMode()"
  />
</template>

<script setup>
import { onMounted, computed, ref } from 'vue';
import { useRouter } from 'vue-router';
import { NavBar, NavSideBar, DebugInfo, FooterBar, localStorageManager } from '@r7e/shared';
import { getR7eApp } from './services/api';

const r7eApp = getR7eApp();
const build_info = ref("");

let loadedBuildInfo = null;
try {
  // Dynamically import buildInfo.json if it exists
  loadedBuildInfo = require('./buildInfo.json');
} catch (e) {
  // buildInfo.json does not exist, skip it
  loadedBuildInfo = null;
}

build_info.value = computed(() => {
  let str = "Build";
  if (process.env.NODE_ENV !== 'production') {
    str += " (" + process.env.NODE_ENV + ")";
  }
  if (loadedBuildInfo) {
    str += " - " + loadedBuildInfo.version;
    if (process.env.NODE_ENV !== 'production') {
      str += " - " + loadedBuildInfo.git.branch;
    }
    str += " - " + loadedBuildInfo.git.hashShort;
    // str += " # " + loadedBuildInfo.buildTime;
    // str += " - " + loadedBuildInfo.git.hash;
  }
  console.log('build_info', build_info.value, loadedBuildInfo?.buildTime);
  return str;
});

const getAppNavBarData = () => {
  // console.log('getAppNavBarData =', this);
  if (r7eApp) {
    return r7eApp.getNavBarData();
  }
  return null;
};

onMounted(() => {
  // console.log('onMounted =', this, r7eApp);

  // Initialize sidebar width CSS custom property
  // This ensures the container has the correct margin even before SideBar component mounts
  if (r7eApp.useSidebar()) {
    const isCollapsed = localStorageManager.getItem('sidebarCollapsed') === 'true';
    document.documentElement.style.setProperty(
      '--sidebar-width',
      isCollapsed ? '70px' : '280px'
    );
  }

  // Try to load credentials on app start
  r7eApp.loadCredentials();
  // console.log('App.vue, onMounted, loadCredentials');
  const isAuthenticated = r7eApp.isAuthenticated();
  const router = useRouter();

  if (isAuthenticated) {
    r7eApp.requestAccountRefresh();
    // If already authenticated and on login page, redirect
    if (r7eApp.hasPendingRegistrationForCurrentService()) {
      // console.log('App.vue, onMounted, hasPendingRegistrationForCurrentService');
      router.push('/profile-setup');
    } else if (router.currentRoute.value.path === '/login') {
      router.push('/');
    }
  } else {
    // If not authenticated and not on login page, redirect to login
     if (router.currentRoute.value.meta.requiresAuth) {
        router.push('/login');
     }
  }
});
</script>

<style>
/* Shared styles are imported from @r7e/shared/styles/variables.css in main.js */
</style>